import { render, staticRenderFns } from "./DiaAplicacionSubTab.vue?vue&type=template&id=9288fc08&"
import script from "./DiaAplicacionSubTab.vue?vue&type=script&lang=js&"
export * from "./DiaAplicacionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports